import { Observable } from 'rxjs';

export class BlobConvert {
  public static blobToText(blob: Blob): Observable<string> {
    // tslint:disable-next-line: no-any
    return new Observable<string>((observer: any) => {
      if (!blob) {
        observer.next('');
        observer.complete();
      } else {
        const reader = new FileReader();
        reader.onload = event => {
          // tslint:disable-next-line: no-any
          observer.next((event.target as any).result);
          observer.complete();
        };
        reader.readAsText(blob);
      }
    });
  }
}
